import React from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'

import {
    to12Hr
} from '../../../helpers/moment'

const CancelledShift = ({ history, schedule, notification }) => {
    return (
        <div className="container">
            {
                schedule && (
                    <React.Fragment>
                        <div className="py-4 text-muted text-center" style={{ fontSize: '0.8rem' }}>{moment(notification.createdAt).fromNow()}, {to12Hr(moment(notification.createdAt))}</div>
                        <h5>{notification.title}</h5>
                        <div>
                            You recently cancelled a shift for {moment(schedule.date, 'YYYY-MM-DD').format('D MMMM YYYY')}, {schedule.shift.name} ({to12Hr(moment(schedule.shift.start_time, 'HH:mm:ss'))} - {to12Hr(moment(schedule.shift.end_time, 'HH:mm:ss'))}).
                            <br />
                            <br />
                            You are required to present and declare a Medical Leave certification within 48 hours, else you will be marked as absent.
                            
                            <button 
                                style={{ marginTop: '100px' }} 
                                className="btn btn-block btn-outline-brand"
                                onClick={() => history.push({
                                    pathname: '/scheduler'
                                })}
                            >Go To Calendar</button>
                        </div>
                    </React.Fragment>
                )
            }
        </div>
    )
}

export default withRouter(CancelledShift)